export const ItemType = { RawMaterial: 1, FinishedGood: 2, VariableItem: 3, Service: 4 } as const;

export const isProduct = (i: { itemTypeID: number }) =>
  i.itemTypeID === ItemType.FinishedGood || i.itemTypeID === ItemType.Service;

export const isStocked = (i: { itemTypeID: number }) => i.itemTypeID !== ItemType.Service;

export const isSellable = (i: { itemTypeID: number; isBuyout?: boolean }) =>
  isProduct(i) || !!i.isBuyout;

/** Sold through a self-referencing BOM rather than built from one: a Service or a Buy Out. */
export const sellsAsIs = (i: { itemTypeID: number; isBuyout?: boolean | null }) =>
  i.itemTypeID === ItemType.Service || !!i.isBuyout;
